export interface ICountry {
  id: string;
  name: string;
  tax: number;
  fyStartMonth: number;
  fyStartDay: number;
}

export enum ECountry {
  Australia = '1',
}
